<template>
    <div>
        <div class="layout__padding-20-0">
            <el-steps :active=stepCount align-center>
                <el-step icon="icon-step-circle text__size-24" title="Select Product Dimensions"></el-step>
                <el-step icon="icon-step-circle text__size-24" title="Select Print Options"></el-step>
                <el-step icon="icon-step-circle text__size-24" title="Price Summary"></el-step>
            </el-steps>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'stepguide',
        props: {
            stepCount: Number
        }
    }
</script>